import { render, staticRenderFns } from "./WallGiftRegistryBlockGeneralSettings.vue?vue&type=template&id=62eec452"
import script from "./WallGiftRegistryBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./WallGiftRegistryBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports